import React from 'react'
import TransactionPage from '../../modules/cassier/TransactionPage'

const Transaksi = () => {
  return (
    <TransactionPage></TransactionPage>
    )
}

export default Transaksi